import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { EvaluationData } from '@core/tellent-assistant-types';
import { AppKind } from '@core/tellent-types';
import { AvatarComponent, IconComponent } from '@core/user-interface-legacy';

import { injectAssistantEntityUrl } from '../../assistant-entity-url';
import { ListCardComponent } from '../../list-card/list-card.component';

@Component({
  selector: 'rt-list-item-evaluation',
  imports: [ListCardComponent, AvatarComponent, IconComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-evaluation.component.html',
  styleUrl: './list-item-evaluation.component.less',
})
export class ListItemEvaluationComponent {
  private readonly entityUrl = injectAssistantEntityUrl();

  protected readonly url = computed(() =>
    this.entityUrl(AppKind.Recruitee, {
      id: 'evaluation',
      params: { candidateId: this.data().candidateId },
    }),
  );

  public readonly data = input.required<EvaluationData>();
}
